import React from "react"
import {Container, Row, Col} from "react-bootstrap";
import { graphql, Link } from "gatsby"
import HTMLReactParser from "html-react-parser";
import "./blockFourCol.scss"

const BlkFourCol = ({content}) => {
  
  return(
      <section className="blk-fourCol">
          <Container>
              <Row>
                  <Col md={3} xs={12}>
                      {HTMLReactParser(content.relationships.block_four_columns_layout_col_1.column_item_content.processed)}
                  </Col>
                  <Col md={3} xs={12}>
                      {HTMLReactParser(content.relationships.block_four_columns_layout_col_2.column_item_content.processed)}
                  </Col>
                  <Col md={3} xs={12}>
                      {HTMLReactParser(content.relationships.block_four_columns_layout_col_3.column_item_content.processed)}
                  </Col>
                  <Col md={3} xs={12}>
                      {HTMLReactParser(content.relationships.block_four_columns_layout_col_4.column_item_content.processed)}
                  </Col>
              </Row>
          </Container>
      </section>
  )
}

export const query = graphql`
    fragment blockFourColumn on paragraph__block_four_columns_layout{
        internal{
            type
        }
        id
        relationships {
          block_four_columns_layout_col_1 {
            column_item_content {
              processed
            }
          }
          block_four_columns_layout_col_2 {
            column_item_content {
              processed
            }
          }
          block_four_columns_layout_col_3 {
            column_item_content {
              processed
            }
          }
          block_four_columns_layout_col_4 {
            column_item_content {
              processed
            }
          }
        }
    }
`

export default BlkFourCol

